import { render, staticRenderFns } from "./Religions.vue?vue&type=template&id=19575494&"
import script from "./Religions.vue?vue&type=script&lang=js&"
export * from "./Religions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports